// extracted by mini-css-extract-plugin
export var inline = "_vo-0";